import React from "react";

const EducationCard = (props) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "12px",
          marginBottom: "20px",
        }}
      >
        <img
          src={props.logo}
          alt={props.organisation}
          style={{
            width: "52px",
            height: "52px",
            objectFit: "cover",
            borderRadius: "50%",
            zIndex: 2,
          }}
        />
        <div>
          <h4
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "4px",
              marginTop: "0",
              lineHeight: "1.5",
            }}
          >
            {props.organisation}
          </h4>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "gray",
            }}
          >
            {props.from}
          </div>
        </div>
      </div>
      <ol
        style={{
          position: "relative",
          borderLeft: "1px solid gray",
          paddingLeft: "20px",
        }}
      >
        {props.positions.map((position, index) => (
          <li
            key={index}
            style={{
              marginBottom: index === props.positions.length - 1 ? "0" : "20px",
            }}
          >
            <div
              style={{
                background: "black",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                position: "absolute",
                left: "-5.7px",
                marginTop: "5px",
              }}
            ></div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "bolder",
                color: "#454545",
                marginBottom: "4px",
                marginTop: "0",
                lineHeight: "1.5",
              }}
            >
              {position.title}
            </h3>
            <time
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "gray",
              }}
            >
              {position.duration}
            </time>
            {position.content.map((info, index) => {
              const parts = info.text.split("see certificate");

              return (
                <div
                  key={index}
                  style={{
                    fontSize: "14px",
                    marginTop: "10px",
                    marginBottom: "0",
                    color: "gray",
                    fontWeight: "normal",
                    whiteSpace: "pre-line",
                  }}
                >
                  {parts.map((part, i) => (
                    <React.Fragment key={i}>
                      {part}
                      {i < parts.length - 1 && (
                        <a
                          href="/certificates/clg-floric.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "rgb(62, 137, 247)",
                            marginLeft: "4px",
                          }}
                        >
                          see certificate
                        </a>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              );
            })}

            <p
              style={{
                fontSize: "14px",
                marginTop: "4px",
                marginBottom: "0",
                color: "gray",
                fontWeight: "normal",
                lineHeight: "1.5",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            ></p>
          </li>
        ))}
      </ol>
    </>
  );
};

export default EducationCard;
